/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, getProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {$SpinBtn, SpinBtnBaseProps} from './SpinBtn';
import {ResponsiveConf} from '@gongxigames/framework/core/fragments/display/responsive';

export type {SpinBtnMode, SpinBtnCurrentAction} from './SpinBtn';
export type SpinBtnUiProps = SpinBtnBaseProps;

export const $SpinBtnUi: FC<SpinBtnUiProps> = (props) => {
    const responsive = Store.computed(() => {
        return slotStore.stage_isPortrait.value ? {
            box: {x: '50%', y: '100%'},
            translate: { y: `${-352 - getProp(props.buttonOffset)}px`}
        } as ResponsiveConf : {
            box: {x: '100%', y: '100%'},
            translate: {x: '-188px', y: '-442px'}
        } as ResponsiveConf;
    });

    return <$SpinBtn {...props} responsive={responsive}/>;
};